import { render, staticRenderFns } from "./PainelOportunidades.vue?vue&type=template&id=0d3687bc"
import script from "./PainelOportunidades.vue?vue&type=script&lang=js"
export * from "./PainelOportunidades.vue?vue&type=script&lang=js"
import style0 from "./PainelOportunidades.vue?vue&type=style&index=0&id=0d3687bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports